export const EventLineType = {
  Generic: 'generic',
  Timing: 'timing',
}

export const ImportExportChartType = {
  Cat2edito: 'cat2edito',
  Danoni: 'danoni',
  DanoniSkbEditor: 'danoniSkbEditor',
  // Osu: 'osu',
}

export const ImportExportEventType = {
  Note: 'note',
  EventLine: 'eventLine',
}

const danoniParameters = {
  scoreNumber: 1,
  blankFrame: 200,
}

// reminder: dont change the key names order without thinking, it is needed to determine danoniSkbEditor keys
export const danoniKeysConfig =
{
  "1": {
    names: ["space"]
    , colours: ["#000"]
    , parameters: danoniParameters
  }
  , "3i": {
    names: ["left", "leftdia", "down"]
    , colours: ["#000", "#000", "#000"]
    , parameters: danoniParameters
  }
  , "4GT": {
    names: ['left', 'down', 'up', 'right']
    , colours: ["#F00", "#0F0", "#00F", "#FF0"]
    , parameters: danoniParameters
  }
  , "5": {
    names: ["left", "down", "up", "right", "space"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#000"]
    , parameters: danoniParameters
  }
  , "5m": {
    names: ["left", "down", "up", "right", "space", "aleft", "adown", "aup", "aright", "aspace", "bleft", "bdown", "bup", "bright", "bspace"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#000", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "5e": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#F00", "#000", "#00F", "#000", "#00F", "#000", "#F00"]
    , parameters: danoniParameters
  }
  , "5g": {
    names: ["left", "down", "up", "right", "space"]
    , colours: ["#000", "#000", "#000", "#000", "#000"]
    , parameters: danoniParameters
  }
  , "5p": {
    names: ["leftdia", "down", "space", "up", "rightdia"]
    , colours: ["#00F", "#F00", "#000", "#F00", "#00F"]
    , parameters: danoniParameters
  }
  , "6": {
    names: ["left", "leftdia", "down", "rightdia", "right", "space"]
    , colours: ["#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000"]
    , parameters: danoniParameters
  }
  , "6s": {
    names: ["space", "left", "down", "up", "right", "sleft"]
    , colours: ["#000", "#F00", "#F00", "#F00", "#F00", "#000"]
    , parameters: danoniParameters
  }
  , "7": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#000", "#00F", "#000", "#00F", "#000", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "7i": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#000", "#000", "#000", "#F00", "#F00", "#F00", "#F00"]
    , parameters: danoniParameters
  }
  , "7h": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#00F", "#0F0", "#F00", "#000", "#F00", "#0F0", "#00F"]
    , parameters: danoniParameters
  }
  , "7p": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#F00", "#00F", "#000", "#00F", "#000", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "7e": {
    names: ["oni", "left", "down", "gor", "up", "right", "space", "sleft", "sright"]
    , colours: ["#0F0", "#000", "#00F", "#000", "#00F", "#000", "#0F0", "#F00", "#F00"]
    , parameters: danoniParameters
  }
  , "7d": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#000", "#00F", "#000", "#00F", "#000", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "8": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right", "sleft"]
    , colours: ["#000", "#00F", "#000", "#00F", "#000", "#00F", "#F00"]
    , parameters: danoniParameters
  }
  , "8D": {
    names: ["oni", "left", "down", "up", "right", "sleft", "sdown", "sup", "sright", "space"]
    , colours: ["#000", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#000"]
    , parameters: danoniParameters
  }
  , "8DR": {
    names: ['lCym', 'hh', 'sn', 'bd', 'hTom', 'lTom', 'fTom', 'rCym']
    , colours: ["#00F", "#0FF", "#FF0", "#000", "#F00", "#0F0", "#FA0", "#00F"]
    , parameters: danoniParameters
  }
  , "8GT": {
    names: ['left', 'down', 'up', 'right', 'sleft', 'sdown', 'sup', 'sright']
    , colours: ["#F00", "#FA0", "#FD0", "#0F0", "#0FA", "#0FF", "#00F", "#F0F"]
    , parameters: danoniParameters
  }
  , "8i": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right", "sleft"]
    , colours: ["#00F", "#00F", "#00F", "#000", "#0F0", "#0F0", "#0F0", "#0F0"]
    , parameters: danoniParameters
  }
  , "9A": {
    names: ["left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright"]
    , colours: ["#00F", "#00F", "#00F", "#00F", "#000", "#0F0", "#0F0", "#0F0", "#0F0"]
    , parameters: danoniParameters
  }
  , "9B": {
    names: ["left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright"]
    , colours: ["#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F"]
    , parameters: danoniParameters
  }
  , "9d": {
    names: ["left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright"]
    , colours: ["#0F0", "#00F", "#0F0", "#000", "#000", "#000", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "9v": {
    names: ["left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright"]
    , colours: ["#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F"]
    , parameters: danoniParameters
  }
  , "9g": {
    names: ["left", "down", "up", "right", "sleft", "sdown", "sup", "sright", "space"]
    , colours: ["#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "9i": {
    names: ["sleft", "sdown", "sup", "sright", "left", "down", "up", "right", "space"]
    , colours: ["#000", "#000", "#000", "#000", "#000", "#00F", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "9j": {
    names: ["left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright"]
    , colours: ["#000", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#000"]
    , parameters: danoniParameters
  }
  , "9t": {
    names: ["left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright"]
    , colours: ["#00F", "#00F", "#00F", "#00F", "#000", "#00F", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "10": {
    names: ["left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright", "sspace"]
    , colours: ["#00F", "#00F", "#00F", "#00F", "#000", "#00F", "#00F", "#00F", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "10e": {
    names: ["spaceL", "leftL", "downL", "gorL", "upL", "rightL", "oni", "leftR", "downR", "gorR", "upR", "rightR", "spaceR"]
    , colours: ["#F00", "#000", "#00F", "#000", "#00F", "#000", "#F00", "#000", "#00F", "#000", "#00F", "#000", "#F00"]
    , parameters: danoniParameters
  }
  , "10p": {
    names: ["left", "down", "gor", "up", "right", "sleft", "sdown", "siyo", "sup", "sright"]
    , colours: ["#0F0", "#00F", "#000", "#00F", "#0F0", "#0F0", "#00F", "#000", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "10D": {
    names: ["oni", "left", "down", "up", "right", "sleft", "sdown", "sup", "sright", "space"]
    , colours: ["#000", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#000"]
    , parameters: danoniParameters
  }
  , "10R": {
    names: ["left", "down", "up", "right", "gor", "siyo", "sleft", "sdown", "sup", "sright"]
    , colours: ["#00F", "#00F", "#00F", "#00F", "#000", "#000", "#F00", "#F00", "#F00", "#F00"]
    , parameters: danoniParameters
  }
  , "10A": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right", "sleft", "sdown", "sright"]
    , colours: ["#000", "#00F", "#000", "#00F", "#000", "#00F", "#000", "#F00", "#F00", "#F00"]
    , parameters: danoniParameters
  }
  , "11": {
    names: ["sleft", "sdown", "sup", "sright", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#0F0", "#0F0", "#0F0", "#0F0", "#000", "#00F", "#000", "#00F", "#000", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "11L": {
    names: ["sleft", "sdown", "sup", "sright", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#0F0", "#0F0", "#0F0", "#0F0", "#000", "#00F", "#000", "#00F", "#000", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "11R": {
    names: ["sleft", "sdown", "sup", "sright", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#0F0", "#0F0", "#0F0", "#0F0", "#000", "#00F", "#000", "#00F", "#000", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "11n": {
    names: ["sleft", "sdown", "sup", "sright", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#0F0", "#0F0", "#0F0", "#0F0", "#000", "#00F", "#000", "#00F", "#000", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "11g": {
    names: ["left", "down", "up", "right", "space", "leftdia", "sleft", "sdown", "sup", "sright", "rightdia"]
    , colours: ["#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "11f": {
    names: ["left", "leftdia", "down", "space", "up", "rightdia", "right", "sleft", "sdown", "sup", "sright"]
    , colours: ["#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "11i": {
    names: ["left", "down", "gor", "up", "right", "space", "sleft", "sdown", "siyo", "sup", "sright"]
    , colours: ["#0F0", "#0F0", "#000", "#0F0", "#0F0", "#000", "#00F", "#00F", "#000", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "11j": {
    names: ["gor", "left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright", "siyo"]
    , colours: ["#000", "#0F0", "#0F0", "#0F0", "#0F0", "#000", "#00F", "#00F", "#00F", "#00F", "#000"]
    , parameters: danoniParameters
  }
  , "11W": {
    names: ["sleft", "sdown", "sup", "sright", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#000", "#F00", "#F00", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "12": {
    names: ["sleft", "sdown", "sup", "sright", "oni", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "12L": {
    names: ["sleft", "sdown", "sup", "sright", "left", "leftdia", "down", "space", "up", "rightdia", "right", "oni"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000"]
    , parameters: danoniParameters
  }
  , "12i": {
    names: ["oni", "left", "leftdia", "down", "space", "up", "rightdia", "right", "sleft", "sdown", "sup", "sright"]
    , colours: ["#00F", "#0F0", "#00F", "#0F0", "#F00", "#F00", "#F00", "#F00", "#0F0", "#00F", "#0F0", "#00F"]
    , parameters: danoniParameters
  }
  , "12W": {
    names: ["left", "down", "up", "right", "sleft", "sdown", "sup", "sright", "aleft", "adown", "aup", 'aright']
    , colours: ["#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "13": {
    names: ["tleft", "tdown", "tup", "tright", "left", "down", "up", "right", "space", "sleft", "sdown", "sup", "sright"]
    , colours: ["#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#000", "#00F", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "13i": {
    names: ["spaceL", "leftL", "downL", "gorL", "upL", "rightL", "oni", "leftR", "downR", "gorR", "upR", "rightR", "spaceR"]
    , colours: ["#F00", "#0F0", "#00F", "#000", "#00F", "#0F0", "#000", "#0F0", "#00F", "#000", "#00F", "#0F0", "#F00"]
    , parameters: danoniParameters
  }
  , "14": {
    names: ["sleftdia", "sleft", "sdown", "sup", "sright", "srightdia", "oni", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#FF0", "#F00", "#F00", "#F00", "#F00", "#FF0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "14i": {
    names: ["gor", "space", "iyo", "left", "down", "up", "right", "sleft", "sleftdia", "sdown", "sspace", "sup", "srightdia", "sright"]
    , colours: ["#000", "#000", "#000", "#F00", "#F00", "#F00", "#F00", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "15A": {
    names: ["sleft", "sdown", "sup", "sright", "tleft", "tdown", "tup", "tright", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "15B": {
    names: ["sleft", "sdown", "sup", "sright", "tleft", "tdown", "tup", "tright", "left", "leftdia", "down", "space", "up", "rightdia", "right"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "16": {
    names: ["sleft", "sdown", "space", "sup", "sright", "aleft", "adown", "aup", "gor", "aright", "oni", "left", "iyo", "down", "up", "right"]
    , colours: ["#000", "#F00", "#000", "#F00", "#000", "#00F", "#00F", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "16i": {
    names: ["gor", "space", "iyo", "left", "down", "up", "right", "sleft", "sdown", "sup", "sright", "aspace", "aleft", "adown", "aup", "aright"]
    , colours: ["#000", "#000", "#000", "#F00", "#F00", "#F00", "#F00", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F"]
    , parameters: danoniParameters
  }
  , "17": {
    names: ["aleft", "bleft", "adown", "bdown", "aup", "bup", "aright", "bright", "space", "cleft", "dleft", "cdown", "ddown", "cup", "dup", "cright", "dright"]
    , colours: ["#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F"]
    , parameters: danoniParameters
  }
  , "18": {
    names: ["sleft", "sdown", "sup", "sright", "space", "aleft", "adown", "aup", "aright", "left", "leftdia", "down", "gor", "oni", "iyo", "up", "rightdia", "right"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#000", "#F00", "#F00", "#F00", "#F00", "#00F", "#00F", "#00F", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "18t": {
    names: ["aa", "ab", "ac", "ba", "bb", "bc", "ca", "cb", "cc", "a2a", "a2b", "a2c", "b2a", "b2b", "b2c", "c2a", "c2b", "c2c"]
    , colours: ["#F00", "#F00", "#F00", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "20": {
    names: ['aleft', 'adown', 'aup', 'aright', 'sleft', 'sdown', 'sup', 'sright', 'bleft', 'bdown', 'bup', 'bright', 'oni', 'left', 'leftdia', 'down', 'space', 'up', 'rightdia', 'right']
    , colours: ["#F00", "#F00", "#F00", "#F00", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "00F", "#00F", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "22": {
    names: ['aleft', 'adown', 'aspace', 'aup', 'aright', 'sspace', 'bleft', 'bdown', 'bspace', 'bup', 'bright', 'cleft', 'cdown', 'cspace', 'cup', 'cright', 'space', 'dleft', 'ddown', 'dspace', 'dup', 'dright']
    , colours: ["#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#F00", "#FF0", "#F00", "#FF0", "#F00", "#000", "#F00", "#FF0", "#F00", "#FF0", "#F00"]
    , parameters: danoniParameters
  }
  , "23": {
    names: ['aleft', 'adown', 'aup', 'aright', 'bleft', 'bdown', 'bup', 'bright', 'left', 'leftdia', 'down', 'space', 'up', 'rightdia', 'right', 'oni', 'sleft', 'sleftdia', 'sdown', 'sspace', 'sup', 'srightdia', 'sright']
    , colours: ["#FF0", "#FF0", "#FF0", "#FF0", "#F00", "#F00", "#F00", "#F00", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "24": {
    names: ['sleftL', 'sdownL', 'supL', 'srightL', 'oniL', 'sleftR', 'sdownR', 'supR', 'srightR', 'leftL', 'leftdiaL', 'downL', 'spaceL', 'upL', 'rightdiaL', 'rightL', 'oniR', 'leftR', 'leftdiaR', 'downR', 'spaceR', 'upR', 'rightdiaR', 'rightR']
    , colours: ["#FF0", "#FF0", "#FF0", "#FF0", "#000", "#F00", "#F00", "#F00", "#F00", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "27": {
    names: ['aleftdia', 'aleft', 'adown', 'aup', 'aright', 'arightdia', 'bleftdia', 'bleft', 'bdown', 'bup', 'bright', 'brightdia', 'left', 'leftdia', 'down', 'space', 'up', 'rightdia', 'right', 'oni', 'sleft', 'sleftdia', 'sdown', 'sspace', 'sup', 'srightdia', 'sright']
    , colours: ["#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#F00", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#000", "#0F0", "#00F", "#0F0", "#00F", "#0F0", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "33": {
    names: ['0left', '0down', '0up', '0right', '1left', '1down', '1up', '1right', '2left', '2down', '2up', '2right', '3left', '3down', '3up', '3right', '4left', '4down', '4up', '4right', '5left', '5down', '5up', '5right', '6left', '6down', '6up', '6right', 'space', '7left', '7down', '7up', '7right']
    , colours: ["#00F", "#00F", "#00F", "#00F", "#0FF", "#0FF", "#0FF", "#0FF", "#00F", "#00F", "#00F", "#00F", "#0FF", "#0FF", "#0FF", "#0FF", "#FF0", "#FF0", "#FF0", "#FF0", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#000", "#0F0", "#0F0", "#0F0", "#0F0"]
    , parameters: danoniParameters
  }
  , "33o": {
    names: ['aleft', 'adown', 'aup', 'aright', 'bleft', 'bdown', 'bup', 'bright', 'cleft', 'cdown', 'cup', 'cright', 'dleft', 'ddown', 'dup', 'dright', 'space', 'eleft', 'edown', 'eup', 'eright', 'fleft', 'fdown', 'fup', 'fright', 'gleft', 'gdown', 'gup', 'gright', 'hleft', 'hdown', 'hup', 'hright']
    , colours: ["#FF0", "#FF0", "#FF0", "#FF0", "#F00", "#F00", "#F00", "#F00", "#0FF", "#0FF", "#0FF", "#0FF", "#00F", "#00F", "#00F", "#00F", "#000", "#00F", "#00F", "#00F", "#00F", "#0FF", "#0FF", "#0FF", "#0FF", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0"]
    , parameters: danoniParameters
  }
  , "50": {
    names: ['leftL', 'downL', 'gorL', 'upL', 'rightL', 'sleftL', 'sdownL', 'siyoL', 'supL', 'srightL', 'leftR', 'downR', 'gorR', 'upR', 'rightR', 'sleftR', 'sdownR', 'siyoR', 'supR', 'srightR', 'leftLR', 'downLR', 'gorLR', 'upLR', 'rightLR', 'sleftLR', 'sdownLR', 'siyoLR', 'supLR', 'srightLR', 'leftB', 'downB', 'gorB', 'upB', 'rightB', 'sleftB', 'sdownB', 'siyoB', 'supB', 'srightB', 'left', 'down', 'gor', 'up', 'right', 'sleft', 'sdown', 'siyo', 'sup', 'sright']
    , colours: ["#FF0", "#FF0", "#FF0", "#FF0", "#FF0", "#F00", "#F00", "#F00", "#F00", "#F00", "#0FF", "#0FF", "#0FF", "#0FF", "#0FF", "#00F", "#00F", "#00F", "#00F", "#00F", "#F0F", "#F0F", "#F0F", "#F0F", "#F0F", "#F00", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#FF0", "#F00", "#F00", "#F00", "#F00", "#F00", "#0FF", "#0FF", "#0FF", "#0FF", "#0FF", "#00F", "#00F", "#00F", "#00F", "#00F"]
    , parameters: danoniParameters
  }
  , "himsiyauz": {
    names: ['1x', 'yx', 'ux', 'ix', 'ax', 'zx', 'sx', 'hx', 'mx']
    , colours: ["#000", "#F00", "#F00", "#F00", "#00F", "#0F0", "#00F", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "cjhamces": {
    names: ['left', 'down', 'up', 'sright', 'right', 'sleft', 'sdown', 'sup']
    , colours: ["#000", "#000", "#000", "#F0F", "#F0F", "#F00", "#F00", "#0F0"]
    , parameters: danoniParameters
  }
  , "tanoshii": {
    names: ['1x', 'tx', 'ix', 'ox', 'ax', 'sx', 'hx', 'nx']
    , colours: ["#000", "#F0F", "#F00", "#F00", "#00F", "#00F", "#00F", "#0F0"]
    , parameters: danoniParameters
  }
  , "99": {
    names: ['0g', '0l', '0d', '0u', '0r', '0ll', '0dd', '0uu', '0rr', '0i', '0lll', '0ddd', '0uuu', '0rrr', '1g', '1l', '1d', '1u', '1r', '1ll', '1dd', '1uu', '1rr', '1i', '1lll', '1ddd', '1uuu', '1rrr', '2g', '2l', '2d', '2u', '2r', '2ll', '2dd', '2uu', '2rr', '2i', '2lll', '2ddd', '2uuu', '2rrr', '3g', '3l', '3d', '3u', '3r', '3ll', '3dd', '3uu', '3rr', '3i', '3lll', '3ddd', '3uuu', '3rrr', '4g', '4l', '4d', '4u', '4r', '4ll', '4dd', '4uu', '4rr', '4i', '4lll', '4ddd', '4uuu', '4rrr', '5g', '5l', '5d', '5u', '5r', '5ll', '5dd', '5uu', '5rr', '5i', '5lll', '5ddd', '5uuu', '5rrr', '6g', '6l', '6d', '6u', '6r', '6ll', '6dd', '6uu', '6rr', '6i', '6lll', '6ddd', '6uuu', '6rrr', 'space']
    , colours: ['#000', '#0F0', '#0F0', '#0F0', '#0F0', '#00F', '#00F', '#00F', '#00F', '#000', '#F00', '#F00', '#F00', '#F00', '#000', '#0F0', '#0F0', '#0F0', '#0F0', '#00F', '#00F', '#00F', '#00F', '#000', '#F00', '#F00', '#F00', '#F00', '#000', '#0F0', '#0F0', '#0F0', '#0F0', '#00F', '#00F', '#00F', '#00F', '#000', '#F00', '#F00', '#F00', '#F00', '#000', '#0F0', '#0F0', '#0F0', '#0F0', '#00F', '#00F', '#00F', '#00F', '#000', '#F00', '#F00', '#F00', '#F00', '#000', '#0F0', '#0F0', '#0F0', '#0F0', '#00F', '#00F', '#00F', '#00F', '#000', '#F00', '#F00', '#F00', '#F00', '#000', '#0F0', '#0F0', '#0F0', '#0F0', '#00F', '#00F', '#00F', '#00F', '#000', '#F00', '#F00', '#F00', '#F00', '#000', '#0F0', '#0F0', '#0F0', '#0F0', '#00F', '#00F', '#00F', '#00F', '#000', '#F00', '#F00', '#F00', '#F00', '#000']
    , parameters: danoniParameters
  }
  , "397": {
    names: ["0left", "0down", "0up", "0right", "1left", "1down", "1up", "1right", "2left", "2down", "2up", "2right", "3left", "3down", "3up", "3right", "4left", "4down", "4up", "4right", "5left", "5down", "5up", "5right", "6left", "6down", "6up", "6right", "7left", "7down", "7up", "7right", "8left", "8down", "8up", "8right", "9left", "9down", "9up", "9right", "10left", "10down", "10up", "10right", "11left", "11down", "11up", "11right", "12left", "12down", "12up", "12right", "13left", "13down", "13up", "13right", "14left", "14down", "14up", "14right", "15left", "15down", "15up", "15right", "16left", "16down", "16up", "16right", "17left", "17down", "17up", "17right", "18left", "18down", "18up", "18right", "19left", "19down", "19up", "19right", "20left", "20down", "20up", "20right", "21left", "21down", "21up", "21right", "22left", "22down", "22up", "22right", "23left", "23down", "23up", "23right", "24left", "24down", "24up", "24right", "25left", "25down", "25up", "25right", "26left", "26down", "26up", "26right", "27left", "27down", "27up", "27right", "28left", "28down", "28up", "28right", "29left", "29down", "29up", "29right", "30left", "30down", "30up", "30right", "31left", "31down", "31up", "31right", "32left", "32down", "32up", "32right", "33left", "33down", "33up", "33right", "34left", "34down", "34up", "34right", "35left", "35down", "35up", "35right", "36left", "36down", "36up", "36right", "37left", "37down", "37up", "37right", "38left", "38down", "38up", "38right", "39left", "39down", "39up", "39right", "40left", "40down", "40up", "40right", "41left", "41down", "41up", "41right", "42left", "42down", "42up", "42right", "43left", "43down", "43up", "43right", "44left", "44down", "44up", "44right", "45left", "45down", "45up", "45right", "46left", "46down", "46up", "46right", "47left", "47down", "47up", "47right", "48left", "48down", "48up", "48right", "49left", "49down", "49up", "49right", "50left", "50down", "50up", "50right", "51left", "51down", "51up", "51right", "52left", "52down", "52up", "52right", "53left", "53down", "53up", "53right", "54left", "54down", "54up", "54right", "55left", "55down", "55up", "55right", "56left", "56down", "56up", "56right", "57left", "57down", "57up", "57right", "58left", "58down", "58up", "58right", "59left", "59down", "59up", "59right", "60left", "60down", "60up", "60right", "61left", "61down", "61up", "61right", "62left", "62down", "62up", "62right", "63left", "63down", "63up", "63right", "64left", "64down", "64up", "64right", "65left", "65down", "65up", "65right", "66left", "66down", "66up", "66right", "67left", "67down", "67up", "67right", "68left", "68down", "68up", "68right", "69left", "69down", "69up", "69right", "70left", "70down", "70up", "70right", "71left", "71down", "71up", "71right", "72left", "72down", "72up", "72right", "73left", "73down", "73up", "73right", "74left", "74down", "74up", "74right", "75left", "75down", "75up", "75right", "76left", "76down", "76up", "76right", "77left", "77down", "77up", "77right", "78left", "78down", "78up", "78right", "79left", "79down", "79up", "79right", "80left", "80down", "80up", "80right", "81left", "81down", "81up", "81right", "82left", "82down", "82up", "82right", "83left", "83down", "83up", "83right", "84left", "84down", "84up", "84right", "85left", "85down", "85up", "85right", "86left", "86down", "86up", "86right", "87left", "87down", "87up", "87right", "88left", "88down", "88up", "88right", "89left", "89down", "89up", "89right", "90left", "90down", "90up", "90right", "91left", "91down", "91up", "91right", "92left", "92down", "92up", "92right", "93left", "93down", "93up", "93right", "94left", "94down", "94up", "94right", "95left", "95down", "95up", "95right", "96left", "96down", "96up", "96right", "97left", "97down", "97up", "97right", "98left", "98down", "98up", "98right", "space"]
    , colours: ["#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#00F", "#00F", "#00F", "#00F", "#F00", "#F00", "#F00", "#F00", "#FF0", "#FF0", "#FF0", "#FF0", "#0F0", "#0F0", "#0F0", "#0F0", "#000"]
    , parameters: danoniParameters
  }
}

